// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const transformationsMap = {
    product_thumbnil: "w_100",
    product_sm: "w_190",
    product_md: "w_350",
    product_lg: "w_800",
};

const cloudinary = (baseURL: string, imageUrl: string | undefined, transformations: string) => {
    if (!imageUrl || !baseURL || !transformations) {
        return imageUrl;
    }
    const transformedPath = transformations
        .split(" ")
        .reduce(
            (currentPath, transformation) => currentPath.split(baseURL).join(`${baseURL}/${transformation}`),
            imageUrl,
        );
    return transformedPath.split(baseURL).join(`${baseURL}/f_auto,q_auto`);
};

export default cloudinary;
